import { Component } from "@angular/core";
import {
  NavController,
  LoadingController,
  AlertController,
  ModalController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import { AddSitesModalComponent } from "./add-sites-modal/add-sites-modal";
import { DownloadPDFModalComponent } from "./dowload-pdf-modal/dowload-pdf-modal";

@Component({
  selector: "profile-information-page",
  templateUrl: "index.html",
  providers: [SummaryServiceProvider, WaybillOrderServiceProvider]
})
export class AddSitesPage {
  header_data: any;
  objectKeys = Object.keys;

  sitesCount: any;
  merchantGroupInfo: any;
  tempSitesData: any;
  filterData: any;
  merchantGroupId: any;

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public waybillOrderService: WaybillOrderServiceProvider,
    public summaryService: SummaryServiceProvider,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController
  ) {
    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Add Sites",
      parentReloadData: d => {
        // this.load_cp_data(true)
      }
    };
    this.filterData = JSON.parse(localStorage.getItem("fuFilters"));
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  openCreateSitesModal() {
    this.merchantGroupInfo = this.filterData.managerUserEntity.filter(
      ele => ele.id == this.merchantGroupId
    )[0];
    //this.navCtrl.setRoot(AddSitesModalComponent, { 'data': this.merchantGroupInfo });
    const modal = this.modalCtrl.create(AddSitesModalComponent, {
      data: this.merchantGroupInfo
    });
    modal.onDidDismiss(data => {
      if (data) {
        // this.load_cp_data(data);
      }
    });
    modal.present();
  }

  openDownloadPdfLabelModal() {
    this.merchantGroupInfo = this.filterData.managerUserEntity.filter(
      ele => ele.id == this.merchantGroupId
    )[0];
    const modal = this.modalCtrl.create(DownloadPDFModalComponent, {
      data: this.merchantGroupInfo
    });
    modal.onDidDismiss(data => {
      if (data) {
        // this.load_cp_data(data);
      }
    });
    modal.present();
  }

  createTempSitesAlertController() {
    let message = `Are you sure you want to create ${this.sitesCount} sites for merchant ${this.merchantGroupInfo}`;
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            // this.createTempSites();
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/add-sites/index.ts